export default __webpack_public_path__ + "561ab35d4c7107d6fdd35b39b526e313.svg";